module.exports = __webpack_public_path__ + "mainassets/img/meshlin-double arrow-down-dark.4edd6c7e.svg";